// extracted by mini-css-extract-plugin
module.exports = {"section":"BioSection_section__3NJup","sidebar":"BioSection_sidebar__16iW9","title":"BioSection_title__1H5-m","sidebarTitle":"BioSection_sidebarTitle__YYKdV"};